module.exports = __webpack_public_path__ + "img/乐途_02.0876b961.jpg";